import { Icon } from '@scale/scaleui';
import { useCurrentEditor } from '@tiptap/react';
import useIsEditorEditable from '../../hooks/useIsEditorEditable';
export function QuoteButton() {
  const { editor } = useCurrentEditor();
  const isEditable = useIsEditorEditable();
  if (!editor) return null;
  return (
    <div className="p-2">
      <Icon
        tooltip="Quote"
        tooltipProps={{
          delayDuration: 0,
        }}
        onClick={() => editor.chain().focus().toggleBlockquote().run()}
        icon="quote-left"
        size="sm"
        selected={editor.isActive('blockquote')}
        disabled={!isEditable}
      />
    </div>
  );
}
